var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { I18NLinkV2 as I18NLink, Translate } from "../../../I18N";
import { NeedAuthorization } from "../../Components/UI/NeedAuthorization";
import { Icon } from "../../../UI";
import { PreserveIcon } from "../../../Layout/PreserveIcon";
import { FeatureToggle } from "../../Components/UI/FeatureToggle";
import { useAtomValue } from 'jotai';
import { settingsAtom } from "../../atoms/settingsAtom";

const SettingsNavigation = () => {
  const settings = useAtomValue(settingsAtom);
  const { allowcustomJS } = settings;

  const renderLink = (to, children) => /*#__PURE__*/
  _jsx(I18NLink, {
    to: to,
    activeClassname: "bg-primary-100 text-primary-800 focus:bg-primary-100",
    className: "block p-2 rounded hover:bg-gray-100 focus:bg-gray-100 font-medium text-sm" }, void 0, /*#__PURE__*/

  _jsx("span", { className: "whitespace-nowrap flex items-center gap-1" }, void 0, children)
  );


  return (/*#__PURE__*/
    _jsx("nav", {
      "aria-label": "Settings navigation",
      className: "h-full flex flex-col gap-6 text-sm overflow-y-auto" }, void 0, /*#__PURE__*/

    _jsx("section", { className: "p-4" }, void 0, /*#__PURE__*/
    _jsx("h2", { className: "font-bold text-sm text-gray-500 mb-4 tracking-wider" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Settings")
    ), /*#__PURE__*/
    _jsx("ul", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/account', /*#__PURE__*/_jsx(Translate, {}, void 0, "Account"))), /*#__PURE__*/
    _jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/dashboard', /*#__PURE__*/_jsx(Translate, {}, void 0, "Dashboard"))), /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/users', /*#__PURE__*/_jsx(Translate, {}, void 0, "Users & Groups"))), /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/collection', /*#__PURE__*/_jsx(Translate, {}, void 0, "Collection"))), /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/navlinks', /*#__PURE__*/_jsx(Translate, {}, void 0, "Menu"))), /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/pages', /*#__PURE__*/_jsx(Translate, {}, void 0, "Pages"))), /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/languages', /*#__PURE__*/_jsx(Translate, {}, void 0, "Languages"))), /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/translations', /*#__PURE__*/_jsx(Translate, {}, void 0, "Translations"))), /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/filters', /*#__PURE__*/_jsx(Translate, {}, void 0, "Filters")))
    )
    )
    )
    ), /*#__PURE__*/
    _jsx("section", { className: "p-4 border-t border-gray-200" }, void 0, /*#__PURE__*/
    _jsx(NeedAuthorization, { roles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
    _jsx("h2", { className: "font-bold text-sm text-gray-500 mb-2 tracking-wider" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Metadata")
    )
    ), /*#__PURE__*/
    _jsx("ul", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    _jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/templates', /*#__PURE__*/_jsx(Translate, {}, void 0, "Templates"))), /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/thesauri', /*#__PURE__*/_jsx(Translate, {}, void 0, "Thesauri"))), /*#__PURE__*/
    _jsx("li", {}, void 0,
    renderLink(
      'settings/relationship-types', /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Relationship types")
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(NeedAuthorization, { roles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
    _jsx(FeatureToggle, { feature: "metadata-extraction" }, void 0, /*#__PURE__*/
    _jsx("li", {}, void 0,
    renderLink(
      'settings/metadata_extraction', /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Metadata Extraction")
    )
    )
    ), /*#__PURE__*/
    _jsx(FeatureToggle, { feature: "paragraphExtraction" }, void 0, /*#__PURE__*/
    _jsx("li", {}, void 0,
    renderLink(
      'settings/paragraph-extraction', /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Paragraph Extraction")
    )
    )
    )
    )
    )
    ), /*#__PURE__*/
    _jsx("section", { className: "p-4 border-t border-gray-200" }, void 0, /*#__PURE__*/
    _jsx("h2", { className: "font-bold text-sm text-gray-500 mb-4 tracking-wider" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Tools")
    ), /*#__PURE__*/
    _jsx("ul", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    _jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(FeatureToggle, { feature: "preserve.host" }, void 0, /*#__PURE__*/
    _jsx("li", {}, void 0,
    renderLink(
      '/settings/preserve', /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Preserve"), " ", /*#__PURE__*/_jsx(PreserveIcon, {})
      )
    )
    )
    ), /*#__PURE__*/
    _jsx(FeatureToggle, { feature: "newRelationships" }, void 0, /*#__PURE__*/
    _jsx("li", {}, void 0,
    renderLink(
      '/settings/newrelmigration', /*#__PURE__*/
      _jsx(Translate, {}, void 0, "New Relationships Migration")
    )
    )
    ), /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/activitylog', /*#__PURE__*/_jsx(Translate, {}, void 0, "Activity log"))), /*#__PURE__*/
    _jsx("li", {}, void 0,
    renderLink(
      'settings/customisation',
      allowcustomJS ? /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Global CSS & JS") : /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Global CSS")

    )
    ), /*#__PURE__*/
    _jsx("li", {}, void 0, renderLink('settings/custom-uploads', /*#__PURE__*/_jsx(Translate, {}, void 0, "Uploads")))
    )
    ), /*#__PURE__*/
    _jsx("li", {}, void 0, /*#__PURE__*/
    _jsx("a", {
      href: "https://uwazi.io/page/9852italrtk/support",
      target: "_blank",
      rel: "noopener noreferrer",
      className: "flex items-center gap-1 p-2 rounded hover:bg-gray-100 focus:bg-gray-100 font-medium text-sm whitespace-nowrap" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Documentation"), " ", /*#__PURE__*/_jsx(Icon, { icon: "external-link-alt" })
    )
    )
    )
    )
    ));

};

export { SettingsNavigation };